module.exports = __webpack_public_path__ + "img/heum-work02-new.df0bb89.jpg";